import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { AnnouncementsBannerComponent } from './announcements-banner.component';

@NgModule({
  imports: [SharedModule],
  declarations: [AnnouncementsBannerComponent],
  exports: [AnnouncementsBannerComponent],
})
export class AnnouncementsBannerModule {}
